
let baseApiUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost/v2/mobile/'
const registerTechnician = baseApiUrl + 'technical/'
let verifyToken = baseApiUrl + 'verify_token/'
const getSettings = baseApiUrl + 'get_setting/'

let searchTypes = baseApiUrl + 'type'
let searchNeighborhoods = baseApiUrl + 'city/$cityId/neighborhood/'
let searchCities = baseApiUrl + 'state/$stateId/city/'
let getStates = baseApiUrl + 'country/2/state/'
let getMobilityTypes = baseApiUrl + 'type_mobility/'

let loadAgenda = baseApiUrl + 'visit/'
let loadVisit = baseApiUrl + 'visit/$visitId'
let serviceInfo = baseApiUrl + 'service/$serviceId'
let getServiceHours = baseApiUrl + 'service/$serviceId/time_ranges/'
let getReasons = baseApiUrl + 'reason_reprogramming/'
let visitAction = baseApiUrl + 'visit/$visitId/status/'
let getChargeCategories = baseApiUrl + 'category_charge/'

let saveCharge = baseApiUrl + 'charge/'
let saveBudget = baseApiUrl + 'request_technician/$techRequestId/budget/'
let changeBudgetStatus = baseApiUrl + 'budget/$budgetId/status/'
let deleteCharge = baseApiUrl + 'charge/$chargeId'

let deleteGalleryFile = baseApiUrl + 'request/$requestId/gallery/$fileId'
let saveGalleryFile = baseApiUrl + 'request/$requestId/gallery/'
let savePushToken = baseApiUrl + 'user/token_fcm/'

let getNotifications = baseApiUrl + 'notification/'
let markNotificationAsRead = baseApiUrl + 'notification/$notificationId/read/'
let deleteNotification = baseApiUrl + 'notification/$notificationId/'
let replyToNotification = baseApiUrl + 'request_technician/$techRequestId/reply/'

let loadComments = baseApiUrl + 'chat/$chatId/?top=$top'
let sendComment = baseApiUrl + 'chat/$chatId/'
let markAsReadComments = baseApiUrl + 'chat/$chatId/read'
let terms = baseApiUrl + 'technical/$registerId/tyc/'

const refreshUrl = function (url) {
  baseApiUrl = url
  verifyToken = baseApiUrl + 'verify_token/'
  searchTypes = baseApiUrl + 'type'
  searchNeighborhoods = baseApiUrl + 'city/$cityId/neighborhood/'
  searchCities = baseApiUrl + 'state/$stateId/city/'
  getStates = baseApiUrl + 'country/2/state/'
  getMobilityTypes = baseApiUrl + 'type_mobility/'
  loadAgenda = baseApiUrl + 'visit/'
  loadVisit = baseApiUrl + 'visit/$visitId'
  serviceInfo = baseApiUrl + 'service/$serviceId'
  getServiceHours = baseApiUrl + 'service/$serviceId/time_ranges/'
  getReasons = baseApiUrl + 'reason_reprogramming/'
  visitAction = baseApiUrl + 'visit/$visitId/status/'
  getChargeCategories = baseApiUrl + 'category_charge/'
  saveCharge = baseApiUrl + 'charge/'
  saveBudget = baseApiUrl + 'request_technician/$techRequestId/budget/'
  changeBudgetStatus = baseApiUrl + 'budget/$budgetId/status/'
  deleteCharge = baseApiUrl + 'charge/$chargeId'
  deleteGalleryFile = baseApiUrl + 'request/$requestId/gallery/$fileId'
  saveGalleryFile = baseApiUrl + 'request/$requestId/gallery/'
  savePushToken = baseApiUrl + 'user/token_fcm/'
  getNotifications = baseApiUrl + 'notification/'
  markNotificationAsRead = baseApiUrl + 'notification/$notificationId/read/'
  deleteNotification = baseApiUrl + 'notification/$notificationId/'
  replyToNotification = baseApiUrl + 'request_technician/$techRequestId/reply/'
  loadComments = baseApiUrl + 'chat/$chatId/?top=$top'
  sendComment = baseApiUrl + 'chat/$chatId/'
  markAsReadComments = baseApiUrl + 'chat/$chatId/read'
  terms = baseApiUrl + 'technical/$registerId/tyc/'
}

export {
  baseApiUrl,
  verifyToken,
  registerTechnician,
  searchTypes,
  searchCities,
  getStates,
  loadAgenda,
  loadVisit,
  getMobilityTypes,
  serviceInfo,
  getReasons,
  getServiceHours,
  visitAction,
  getChargeCategories,
  saveCharge,
  saveBudget,
  changeBudgetStatus,
  deleteCharge,
  deleteGalleryFile,
  saveGalleryFile,
  savePushToken,
  getNotifications,
  markNotificationAsRead,
  deleteNotification,
  replyToNotification,
  loadComments,
  markAsReadComments,
  sendComment,
  searchNeighborhoods,
  terms,
  getSettings,
  refreshUrl
}
